import React from 'react'
import {omit} from 'lodash'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import withStyles from '@material-ui/core/styles/withStyles'
import classNames from 'classnames'

const styles = theme => ({
  root: {
    display: 'inline-block',
    alignItems: 'center',
    position: 'relative' as const,
    marginTop: 40,
    [theme.direction === 'rtl' ? 'marginLeft' : 'marginRight']: 15,
    '&.success': {
      backgroundColor: theme.palette.green.color,
    },
    '&.failure': {
      backgroundColor: theme.palette.error.main,
    },
    '&.progress':{
      color: theme.palette.primary.main,
      position: 'absolute' as const,
      top: '50%',
      left: '50%',
      marginTop: -12,
      [theme.direction === 'rtl' ? 'marginRight' : 'marginLeft']: -12,
    },
    '&.noMargin':{
      margin: 0
    },
    '&.noButtonStyle':{
      backgroundColor: 'transparent',
      textAlign: 'inherit' as const
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 10,
    },
    [theme.breakpoints.down('xs')]: {
      [theme.direction === 'rtl' ? 'marginLeft' : 'marginRight']: 0,
    },
  },
})

const LoadingButton = (props) => {
  const {disabled, children, onClick, classes, status, hideProgressBar, fullWidth, className, noMargin, size, variant} = props
  return (
    <Button
      variant={variant || 'contained'}
      color="primary"
      size={size || 'large'}
      disabled={disabled}
      onClick={onClick}
      fullWidth={fullWidth}
      className={classNames(classes.root, status, className, (noMargin) ? 'noMargin' : '')}
      {...omit(props, ['hideProgressBar', 'noMargin', 'className', 'disabled'])}
    >{children} {disabled &&!hideProgressBar && <CircularProgress size={24} className={classNames(classes.root, 'progress')} />}</Button>
  )
}

LoadingButton.propTypes = {
  id: PropTypes.string,
  autoFocus: PropTypes.any,
  disableFocusRipple: PropTypes.any,
  disableRipple: PropTypes.any,
  size: PropTypes.string,
  onKeyPress: PropTypes.func,
  variant: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired,
  status: PropTypes.oneOf(['', 'success', 'failure']),
  hideProgressBar: PropTypes.bool,
  fullWidth: PropTypes.bool,
  noMargin: PropTypes.bool,
}

export default  withStyles(styles)(LoadingButton)
